import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { MeProvider } from "@/context/MeContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Club from "@/pages/Club";
import Marketplace from "@/pages/Marketplace";
import OfferDetail from "@/pages/OfferDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmed from "@/pages/OrderConfirmed";
import Account from "@/pages/Account";
import Partner from "@/pages/Partner";
import Admin from "@/pages/Admin";
import StatusShop from "@/pages/StatusShop";
import Blog, { BlogPost } from "@/pages/Blog";
import About from "@/pages/About";
import Legal from "@/pages/Legal";

const Private = ({ children }) => (
  <>
    <Show when="signed-in">{children}</Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

const AuthPage = ({ children }) => <div className="flex min-h-[70vh] items-center justify-center px-4 py-12">{children}</div>;

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <ClerkAuthProvider>
          <MeProvider>
            <CartProvider>
              <Routes>
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/club" element={<Club />} />
                  <Route path="/diventa-premium" element={<StatusShop />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/chi-siamo" element={<About />} />
                  <Route path="/legal/:slug" element={<Legal />} />
                  <Route path="/marketplace" element={<Marketplace />} />
                  <Route path="/marketplace/:id" element={<OfferDetail />} />
                  <Route path="/carrello" element={<Cart />} />
                  <Route path="/checkout" element={<Private><Checkout /></Private>} />
                  <Route path="/ordine-confermato" element={<Private><OrderConfirmed /></Private>} />
                  <Route path="/account" element={<Private><Account /></Private>} />
                  <Route path="/partner" element={<Private><Partner /></Private>} />
                  <Route path="/admin" element={<Private><Admin /></Private>} />
                  <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
                  <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
                </Route>
              </Routes>
              <Toaster richColors position="top-right" theme="dark" />
            </CartProvider>
          </MeProvider>
        </ClerkAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
